import { render, staticRenderFns } from "./DropdownNested.vue?vue&type=template&id=546dc483&scoped=true&"
import script from "./DropdownNested.vue?vue&type=script&lang=js&"
export * from "./DropdownNested.vue?vue&type=script&lang=js&"
import style0 from "./DropdownNested.vue?vue&type=style&index=0&id=546dc483&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546dc483",
  null
  
)

export default component.exports